/**
 *
 */
class FactoringForm{

    /**
     *
     * @param optionsFactoringForm
     */
    constructor(options) {
        //console.debug('FactoringForm : Construct', options);
        this.options = options;
        this.reponses = [];
        this.reponses[1] = options.reponse1;
        this.getDatas().then(
            (datas) => {
                this.myDatas = datas;
                this.renderView();
            }
        );
    }


    /**
     *
     * @returns {boolean}
     */
    getDatas(){
        return new Promise(( resolve, reject ) =>
            {
                $.ajax({
                    url: this.options.datasPath,
                    type: 'get',
                    // Réussite du transfert
                    success: (answer, status, xhr) => {resolve(answer);},
                    // erreur du transfert
                    error: (xhr, errorType, error) => { reject({xhr, errorType, error});}
                });
            }
        );
    }



    /**
     *
     * @returns {{}}
     */
    renderView(){

        let _self = this;

        let appQwantSearch = new Vue({

            el: _self.options.container,

            // --------------------------------------------------------------------------------------------------------- DATAS
            data() {
                return {
                    lang: _self.options.lang,
                    datas: _self.myDatas,
                    currentQuestion: 1,
                    displayNext: false,
                    offre: false,
                    isMounted: false,
                    answers: [] // sert uniquement pour le debug (aucune utilite)
                }
            },


            computed: {
                question: function() {
                    return  this.datas.questions[this.currentQuestion];
                }
            },


            // --------------------------------------------------------------------------------------------------------- LIFECYCLE
            mounted() {
                //console.debug('_self', _self);
                setTimeout(() => {this.isMounted = true;}, 1000);
                this.selectProp(this.datas.questions[1], _self.options.reponse1);
                this.validateQuestion();
            },

            updated(){
            },

            // --------------------------------------------------------------------------------------------------------- METHODS
            methods:{

                i10n: function (value) {
                    if(value[this.lang] !== undefined){
                        return value[this.lang];
                    } else {
                        return 'trad manquante';
                    }
                },
                clickOnProposition: function(){
                    // on masque
                    TweenMax.to(this.$refs.mainContainer, 0.5, {alpha: 0, onComplete: () => {
                        this.validateQuestion();
                    }});
                },

                /**
                 * Nous validons une question, il va falloir trouver la suivante en fonction des conditions d'affichage des suivantes
                 */
                validateQuestion: function(){
                    //console.debug('validateQuestion', this.currentQuestion);



                    this.displayNext = false;

                    // on a fini les question du coup on calcul la bonne offre
                    if(this.currentQuestion >= (this.datas.questions.length-1)){
                        this.offre = this.getOffre();
                        TweenMax.to(this.$refs.mainContainer, 0.5, {alpha: 1});
                        return;
                    }

                    let nextQuestionCondition = this.datas.questions[this.currentQuestion+1].condition;

                    // on transforme la condition en quelques chose d'utilisable
                    let dynamicCondition = eval(this.transformCondition(nextQuestionCondition, 'this'));

                    this.currentQuestion++;

                    // si la question suivante ne doit pas s'afficher, on affiche la suivante
                    if(!dynamicCondition){
                        this.validateQuestion();
                    }


                    // on affiche
                    TweenMax.to(this.$refs.mainContainer, 0.5, {alpha: 1});

                },

                transformCondition: function(cond, currentObject){
                    //console.debug('transformCondition old :::: ', cond);

                    cond = cond.replace(/et/gi, '&&'); // on replace les ET par &&
                    cond = cond.replace(/ou/gi, '||'); // on remplace les OR par ||

                    // gesion des condition =
                    cond = cond.replace(/(\d)=(\s?[\w]{1,2})/g, currentObject+".questionHasResponse($1, '$2')");

                    // gesion des condition <>
                    cond = cond.replace(/(\d)<>(\s?[\w]{1,2})/g, "!"+currentObject+".questionHasResponse($1, '$2')");

                    //console.debug('transformCondition new :::: ', cond);
                    return cond;
                },

                /**
                 *
                 * @param questionId
                 * @param val
                 */
                questionHasResponse: function(questionId, val){
                    //console.debug('questionHasResponse', questionId, val);

                    let isTrue = false;

                    // on vérifie l'existence de la question
                    if(this.datas.questions[questionId].propositions === undefined){
                        console.error('questionHasResponse : question '+questionId+' inconnue')
                        return false;
                    }

                    // on regarder si la propal en question a été checkée
                    this.datas.questions[questionId].propositions.forEach((elt, index) => {
                        //console.debug(elt.value, elt.checked);
                       if(elt.value === val && elt.checked === true){
                           isTrue = true;
                        }
                    });

                    return isTrue;
                },

                /**
                 * Permet de trouver la bonne offre en fonction des réponses saisies
                 */
                getOffre: function(){
                    let _self = this;
                    let offre = false;

                    for(let i = 0; i < this.datas.offres.length; i++){
                        let elt = this.datas.offres[i];
                        let dynamicCondition = eval(this.transformCondition(elt.condition, '_self'));
                        if(dynamicCondition){
                            offre = elt;
                            break;
                        }
                    }

                    // on a pas trouvé l'offre
                    if(!offre){
                        console.error('getOffre: pas doffre, bizarre, erreur dans le fichier de conf ?');
                    }

                    // on ajoute un entrée dans les log typo3
                    //console.debug(JSON.stringify(this.datas));
                    let myDatasToSave = {
                        'questions': this.datas.questions,
                        'offre': offre
                    };
                    //SG_addlog('factoringForm', JSON.stringify(myDatasToSave));

                    // on stocke l'offres en question
                    $.cookie('SG_factoringProduct', this.i10n(offre.mainTitle), { path: '/' });

                    return offre;

                },


                /**
                 * Action chand on choisi un propal
                 * @param questionId
                 * @param value
                 */
                selectProp: function(question, value){

                    this.answers.push(question.id + '_' + value);

                    this.datas.questions[question.id].propositions.forEach((elt, index) => {

                        // si on est sur un choix unique, on décoche les choix
                        if(!this.datas.questions[question.id].multiple){
                            this.$set(this.datas.questions[question.id].propositions[index], 'checked', false);
                        }

                        if(elt.value == value){
                            let newVal = (this.datas.questions[question.id].propositions[index].checked == false || this.datas.questions[question.id].propositions[index].checked == undefined );
                            this.$set(this.datas.questions[question.id].propositions[index], 'checked', newVal);
                        }
                    });
                    this.displayNext = true;
                },
            },


        });
    }

}
